import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    root: (props: any) => ({ background: props.palette.profile.pageBackgroundColor })
});
export default useStyles;
